import React, { FC, ReactNode, useEffect, useState } from 'react';
import Modal from '@common/modal';
import Icon from '@common/assets';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './testGuide.module.scss';

const cx = classnames.bind(styles);

interface ILeftContent {
  openTutorialGuideModal?: () => void;
}

interface IStepSlide {
  leftContent: (props: ILeftContent) => ReactNode;
  rightContent: ReactNode;
}

const stepSlideList: IStepSlide[] = [
  {
    leftContent: () => (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          개발 구현 능력 검사는
          <br />
          개발을 통해 문제를 해결하는
          <br />
          능력을 진단합니다.
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step6')} />,
  },
  {
    leftContent: ({ openTutorialGuideModal }) => (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          개발 구현 능력 검사는
          <br />
          단계별로 추가 조건이 제시되기 때문에
          <br />
          코드 확장성이 중요한 검사에요.
        </strong>
        <p className={cx('desc')}>실전 응시 전 미리 연습해 보고 싶다면?</p>
        <button className={cx('btnTutorial')} type={'button'} onClick={openTutorialGuideModal}>
          튜토리얼 바로가기
          <Icon name="arrowRightLight" width={24} height={24} fill={Colors.C_JOBDA_BLACK} />
        </button>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step7')} />,
  },
  {
    leftContent: () => (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          테스트에서
          <br />
          높은 등급을 달성하면,
          <br />
          매칭 받을 확률이 UP!
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'step8')} />,
  },
  {
    leftContent: () => (
      <div className={cx('infoWrap')}>
        <strong className={cx('title')}>
          이제 실전 응시입니다.
          <br /> <br />내 개발능력 검사하러 출발!
        </strong>
      </div>
    ),
    rightContent: <div className={cx('visualArea', 'finish')} />,
  },
];

interface ITestGuideModalProps {
  visible: boolean;
  onClose: () => void;
  onApply: () => void;
  openTutorialGuideModal: () => void;
}

const TestGuideModal: FC<ITestGuideModalProps> = ({ visible, onClose, onApply, openTutorialGuideModal }) => {
  const [stepIndex, setStepIndex] = useState(0);
  const [isDisabledStartBtn, setIsDisabledStartBtn] = useState(false);

  const lastSlideIndex = stepSlideList.length - 1;
  const isLastIndex = stepIndex === lastSlideIndex;
  const leftContentEl = stepSlideList[stepIndex].leftContent({ openTutorialGuideModal }) ?? <></>;
  const rightContentEl = stepSlideList[stepIndex].rightContent ?? <></>;

  const handlePrevStep = () => {
    if (stepIndex - 1 < 0) return;
    setStepIndex(stepIndex - 1);
  };

  const handleNextStep = () => {
    if (stepIndex + 1 > lastSlideIndex) return;
    setStepIndex(stepIndex + 1);
  };

  const onClickStartBtn = () => {
    setIsDisabledStartBtn(true);
    onApply();
  };

  useEffect(() => {
    if (visible) {
      setIsDisabledStartBtn(false);
      setStepIndex(0);
    }
  }, [visible]);

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <div className={cx('infoArea')}>
          <div className={cx('infoInner')}>{leftContentEl}</div>

          <div className={cx('btnArea', `step${stepIndex + 1}`)}>
            {stepIndex > 0 && (
              <a className={cx('btnPrev')} role="button" onClick={handlePrevStep}>
                이전
              </a>
            )}
            {isLastIndex ? (
              <button className={cx('btnNext')} onClick={onClickStartBtn} disabled={isDisabledStartBtn}>
                시작
              </button>
            ) : (
              <button className={cx('btnNext')} type="button" onClick={handleNextStep}>
                다음
              </button>
            )}
          </div>
        </div>
        {rightContentEl}

        <a className={cx('btnClose')} onClick={onClose} role="button">
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default TestGuideModal;
